import { storage } from "./config";

const createBlobAttachment = ({ fullPath, blob }) => {
    // stores the blob in google cloud storage and returns the access url path
    return new Promise(async (resolve, reject) => {
        try {
            const ref = storage.ref().child(fullPath);
            ref.put(blob)
                .then(snapshot => {
                    snapshot.ref.getDownloadURL()
                        .then(resolve)
                        .catch(reject)
                })
                .catch(reject);
        }
        catch (error) {
            reject(error);
        }
    })
}

export {
    createBlobAttachment
}